import React from 'react';
import UsersTable from 'src/components/sharedComponents/Tablas/UsersTable';
import UsersBlockedTable from 'src/components/sharedComponents/Tablas/UsersBlockedTable';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import { minPermisos } from 'src/constants/permits';

import { useStyles } from '../styles';

const AdminControl = ({
  users = [],
  usersBlocked = [],
  columns = [],
  handleEdit,
  handleDelete,
  loading,
  handleClick,
  handleUnlock,
  minValue,
}) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.root}>
        <CardTitle
          title="Administración de usuarios"
          subTitle=" Administre y edite usuarios"
        />
        {minValue >= minPermisos.CREAR ? (
          <Button
            style={{ width: '100%' }}
            type="onSubmit"
            onClick={handleClick}
            color="warning"
          >
            Crear Usuarios
          </Button>
        ) : null}
        <UsersTable
          idPermisoTabla={minValue}
          dataTable={users}
          columns={columns}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          // handleOnChange={() => handleOnChange()}
          // status={false}
          loading={loading}
        />
         <UsersBlockedTable
          idPermisoTabla={minValue}
          dataTable={usersBlocked}
          columns={columns}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleUnlock={handleUnlock}
          loading={loading}
        />
      </div>
    </>
  );
};

export default AdminControl;
